import React, { useState, useEffect } from 'react';

const WHATSAPP_LINK = 'https://web.whatsapp.com/send?phone=2348057795292&text=Hello!%20I%27m%20reaching%20out%20to%20you%20concerning%20my%20NIN%20enquiry';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const handleClick = () => {
    window.open(WHATSAPP_LINK, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleClick}
      className={`whatsapp-float-btn ${isVisible ? 'visible' : ''}`}
      aria-label="Contact us on WhatsApp"
      style={{
        position: 'fixed',
        left: 24,
        bottom: 24,
        zIndex: 9999,
        background: 'transparent',
        border: 'none',
        borderRadius: '50%',
        width: 48,
        height: 48,
        display: isVisible ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        cursor: 'pointer',
        transition: 'opacity 0.3s',
        padding: 0,
      }}
    >
      {/* WhatsApp Icon SVG matching the provided image */}
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="8" fill="#25D366"/>
        <circle cx="20" cy="20" r="13" fill="#25D366" stroke="#fff" strokeWidth="2"/>
        <path d="M27.1 24.6c-.4-.2-2.3-1.1-2.7-1.3-.4-.2-.6-.2-.8.2-.2.3-.9 1.3-1.1 1.5-.2.2-.4.3-.8.1-.4-.2-1.7-.6-3.2-1.9-1.2-1.1-2-2.3-2.2-2.6-.2-.4 0-.6.2-.8.2-.2.4-.4.5-.6.2-.2.2-.4.4-.7.1-.2.1-.5 0-.7-.1-.2-.9-2.1-1.2-2.9-.3-.8-.6-.6-.8-.6-.2 0-.4 0-.7 0-.2 0-.6.1-1 .4-.3.4-1.3 1.3-1.3 3.1 0 1.8 1.3 3.6 1.5 3.8.2.2 2.6 4 6.5 5.4.9.3 1.6.5 2.2.6.9.2 1.7.2 2.3.1.7-.1 2.3-.9 2.6-1.8.3-.9.3-1.6.2-1.8-.1-.2-.3-.3-.7-.5z" fill="#fff"/>
      </svg>
    </button>
  );
};

export default WhatsAppButton; 